import { writable } from 'svelte/store';

interface ConfirmationState {
	show: boolean;
	message: string;
	title?: string;
	resolve: (value: boolean) => void;
}

const initialState: ConfirmationState = {
	show: false,
	message: '',
	resolve: () => {}
};

export const confirmationState = writable<ConfirmationState>(initialState);

export function askConfirmation(message: string, title?: string): Promise<boolean> {
	return new Promise((resolve) => {
		confirmationState.set({
			show: true,
			message,
			title,
			resolve
		});
	});
}

export function answerConfirmation(confirmed: boolean) {
	confirmationState.update((state) => {
		state.resolve(confirmed);
		return initialState;
	});
}
